module.exports = __webpack_public_path__ + "static/img/kr-977-375-75bb.797a332.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/kr-977-375-75bb.jpg
// module id = HtAx
// module chunks = 0